import React from "react";
import { colors } from "../../../../../utils/theme";
import styled from "styled-components";
import Icon from "../../../../../assets/icons/logo.svg";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useDataContex } from "../../../../../hooks/Context/PatientProvider";

const ContainerSession = styled.div`
  display: flex;
  width: 90%;
  margin: 0 auto;
  justify-content: center;
  box-shadow: 1px 1px 5px 1px #00000029;
  border-radius: 5px;
  margin-bottom: 2rem;
`;

const IconContainerSession = styled.div`
  width: 8%;
  background-color: ${colors.secondary};
  border-radius: 10px;

  @media (max-width: 1024px) {
    width: 15%;
  }

  @media (max-width: 768px) {
    border-radius: initial;
  }

  article {
    width: 100%;
    height: 100%;
    padding: 2.5rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 80%;
      height: 80%;
    }
  }
`;

const Section2 = styled.div`
  width: 92%;
  background-color: ${colors.blanco};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    text-align: center;
    padding-right: 4.5em;
    @media (max-width: 768px) {
      padding-right: 0;
    }
    color: ${colors.primary};
    font-size: 1.3rem;
    font-weight: bold;
    margin: 1rem 0;

    @media (max-width: 500px) {
      font-size: 1.1rem;
    }
  }
`;

const ContainerFormSession = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const FormInputInfoSession = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 20px;
  align-items: center;
  flex-direction: column;
  width: 22%;

  @media (max-width: 1024px) {
    width: 40%;
  }

  @media (max-width: 768px) {
    width: 95%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
  }

  input {
    width: 100%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const SingleSessionForm = ({ sesion, onEliminarSesion }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { PatientOrderSession } = location.state;
  const { setPatientInfoContinuidadContex, patientInfoContinuidadContex } =
    useDataContex();
  
  let numeroSesionesSinOrden =
    patientInfoContinuidadContex?.sesionesSinOrden?.sesiones.length;

  let numeroSesionesConOrden = PatientOrderSession?.orders?.sesiones?.length;



  async function CancelarCita(schedSesion, IdNumber, motivo) {
    const url =
      "/apihub/legacy/Service/Agenda/EliminarCita";

    const requestBody = {
      schedSesion: schedSesion,
      numeroDocumento: IdNumber,
      motivo: motivo,
    };
    let timerInterval;
    Swal.fire({
      title: "Cancelando cita!",
      html: "",
      timer: 1200,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    });
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error en la solicitud POST:", error);
    }
  }

  async function RedireccionarPaciente(typeID, IdNumber) {
    const url =
      "/apihub/legacy/Service/Agenda/ContinuidadDePacientes";
    const requestBody = {
      tipoDocumento: typeID,
      numeroDocumento: IdNumber,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        var error = new Error(`HTTP error! status: ${response.status}`) as any;
        error.data = data;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  async function Continuidad_Or_NuevoDiagnostico(
    tipoDocumento,
    numeroDocumento,
    numeroDeOrden,
    idSched
  ) {
    const url =
      "/apihub/legacy/Service/Agenda/ValidarSesionesDeOrden";
    const requestBody = {
      tipoDocumento: tipoDocumento,
      numeroDocumento: numeroDocumento,
      numeroDeOrden: numeroDeOrden,
      idSched: idSched,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        var error = new Error(`HTTP error! status: ${response.status}`) as any;
        error.data = data;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  const alertaCitaCancelada = () => {
    Swal.fire({
      title: "Cita cancelada",
      text: "Tu cita ha sido cancelada.",
      icon: "success",
      timer: 2000, 
      showConfirmButton: false
    });
  }

  const handleInputChange = (newValue) => {
    console.log("");
  };

  const formatHour = (hour) => {
    const displayHour = (hour % 12 === 0 ? 12 : hour % 12).toString();
    const amPm = hour < 12 ? "AM" : "PM";
    return displayHour + ":00 " + amPm;
  };

  const formatHour2 = (hour) => {
    const displayHour = (
      (hour - 1) % 12 === 0 ? 12 : (hour - 1) % 12
    ).toString();
    const amPm = hour < 12 ? "AM" : "PM";
    return displayHour + ":40 " + amPm;
  };

  const hourFinal = formatHour(sesion.hora);
  const hourFinal2 = formatHour2(sesion.hora);

  const handleViewSessions = (e, schedID) => {
    const numeroOrden = sesion.secterapia;
    const IdSesion = sesion.schedId;

    e.preventDefault();
    const schedSesion = schedID.toString();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: true,
      padding: "1rem",
      cancelButtonColor: "#c30909",
      confirmButtonColor: "#013A57",
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro?",
        text: "¿Quieres eliminar esta cita, esta accion no es reversible?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Cancelar cita!",
        cancelButtonText: "Volver",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons
            .fire({
              title: "¿Cuál es el motivo de la cancelación?",
              input: "select",
              icon: "question",
              iconColor: "#545454",
              inputLabel: "Motivo: ",
              inputOptions: {
                "10": "Enfermedad",
                "20": "Trabajo",
                "30": "Transporte",
                "40": "Concurrencia citas",
                "50": "Viaje",
                "60": "Personal",
                "70": "Lluvia",
              },
              inputAttributes: {
                style:
                  "align-items: center; padding: 1rem; border-radius: 10px; border: 1px solid #d9d9d9; font-weight: 600;",
              },
              inputPlaceholder: "Selecciona una opción",
              showCancelButton: true,
              confirmButtonText: "Confirmar",
              cancelButtonText: "Volver",
              reverseButtons: true,
              inputValidator: (value) => {
                return new Promise((resolve) => {
                  if (value) {
                    resolve();
                  } else {
                    resolve("Debes seleccionar una opción");
                  }
                });
              },
            })
            .then((result) => {
              if (result.isConfirmed) {
                Continuidad_Or_NuevoDiagnostico(
                  PatientOrderSession.tipoDocumento,
                  PatientOrderSession.numeroDocumento,
                  numeroOrden,
                  IdSesion
                )
                  .then((data) => {
                    if (data && data.data) {
                      let TipoVisita = data.data.tipoDeVisita;
                      
                      
                      
                      CancelarCita(schedSesion, "1", result.value)
                        .then((data) => {
                          if (data.success) {
                            let errores = data.errors || [];

                            if (errores.length !== 0) {
                              swalWithBootstrapButtons.fire(
                                "Error!",
                                errores[0],
                                "error"
                              );
                            } else {
                              
                              if (
                                numeroSesionesConOrden > 1 
                                && TipoVisita === "NC"
                              ) {
                                onEliminarSesion(schedSesion);
                                Swal.fire({
                                  title: "Tu cita ha sido cancelada",
                                  text: "¿Quiere reagendar su cita?",
                                  icon: "success",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Sí",
                                  cancelButtonText: "No",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    RedireccionarPaciente(
                                      PatientOrderSession.tipoDocumento,
                                      PatientOrderSession.numeroDocumento
                                    )
                                      .then((data) => {
                                        if (data && data.data) {
                                          const dataService = data;
                                          const PatientOrder: IPatientOrderServiceContex =
                                            {
                                              name: dataService.data.name,
                                              numeroDocumento:
                                                dataService.data
                                                  .numeroDocumento,
                                              tipoDocumento:
                                                dataService.data.tipoDocumento,
                                              fechaNacimiento:
                                                dataService.data
                                                  .fechaNacimiento,
                                              email: dataService.data.email,
                                              telefono:
                                                dataService.data.telefono,
                                              orders: dataService.data.orders,
                                            };

                                          let timerInterval;
                                          Swal.fire({
                                            title: "Redireccionado...!",
                                            html: "",
                                            timer: 1200,
                                            timerProgressBar: true,
                                            didOpen: () => {
                                              Swal.showLoading();
                                            },
                                            willClose: () => {
                                              clearInterval(timerInterval);
                                            },
                                          });
                                          setTimeout(() => {
                                            setPatientInfoContinuidadContex(
                                              PatientOrder
                                            );

                                            navigate("/OrderContinuidad");
                                          }, 1500);
                                        } else {
                                          Swal.fire({
                                            title: "¡Error en el formulario!",
                                            icon: "error",
                                            timer: 1500,
                                            html: "error al traer la informacion del paciente",
                                            showConfirmButton: false,
                                          });
                                        }
                                      })
                                      .catch((error) => {
                                        console.log("error", error);
                                        var messege =
                                          error.data.errors.join("</br>");
                                        Swal.fire({
                                          title: "¡Error al direccionar!",
                                          icon: "error",
                                          timer: 3000,
                                          html: messege,
                                          showConfirmButton: false,
                                        });
                                      });
                                  } else {
                                    onEliminarSesion(schedSesion);
                                    alertaCitaCancelada();
                                  }
                                });
                              } else if (
                                numeroSesionesSinOrden > 1 
                                && TipoVisita === "ND"
                              ) {
                                onEliminarSesion(schedSesion);
                                Swal.fire({
                                  title: "Tu cita ha sido cancelada",
                                  text: "¿Quiere reagendar su cita?",
                                  icon: "success",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Sí",
                                  cancelButtonText: "No",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    navigate("/");
                                  } else {
                                    onEliminarSesion(schedSesion);
                                    alertaCitaCancelada();
                                  }
                                });
                              } else {
                                onEliminarSesion(schedSesion);
                                alertaCitaCancelada();
                              }
                            }
                          }
                        })
                        .catch((error) => {
                          console.error("Error al recibir los datos:", error);
                          swalWithBootstrapButtons.fire(
                            "Error!",
                            error,
                            "error"
                          );
                        });
                    } else {
                    }
                  })
                  .catch((error) => {
                    console.log("error", error);
                    var messege = error.data.errors.join("</br>");
                    Swal.fire({
                      title: "¡Error al validar al paciente!",
                      icon: "error",
                      timer: 3000,
                      html: "No se puede validar que tipo de cita tiene el paciente",
                      showConfirmButton: false,
                    });
                  });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                swalWithBootstrapButtons.fire(
                  "Cancelar",
                  "Tu cita no ha sido eliminada.",
                  "error"
                );
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Cancelar",
            "Tu cita no ha sido eliminada.",
            "error"
          );
        }
      });
  };

  return (
    <form onSubmit={(e) => handleViewSessions(e, sesion.schedId)}>
      <ContainerSession>
        <IconContainerSession>
          <article>
            <img src={Icon} alt="" />
          </article>
        </IconContainerSession>

        <Section2>
          <h3>SESIÓN PROGRAMADA</h3>

          <ContainerFormSession>
            <FormInputInfoSession>
              <label>HORA DE LLEGADA</label>
              <input
                type="text"
                value={hourFinal2}
                onChange={(e) => handleInputChange(e.target.value)}
              />
            </FormInputInfoSession>

            <FormInputInfoSession>
              <label>HORA DE ATENCIÓN</label>
              <input
                type="text"
                value={hourFinal}
                onChange={(e) => handleInputChange(e.target.value)}
              />
            </FormInputInfoSession>

            <FormInputInfoSession>
              <label>FECHA ATENCIÓN</label>
              <input
                type="text"
                value={sesion.fechaAtencion}
                onChange={(e) => handleInputChange(e.target.value)}
              />
            </FormInputInfoSession>
          </ContainerFormSession>
          <ContainerButton>
            <button className="button" type="submit">
              CANCELAR CITA
            </button>
          </ContainerButton>
        </Section2>
      </ContainerSession>
    </form>
  );
};

export default SingleSessionForm;
